var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconsTrans(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 206,
    viewBox: "0 0 180 206",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93 204.439L119.059 189.418V159.294L93 174.322V204.439Z",
    fill: "#18113C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120.764 47.8436L146.823 32.7468L120.764 17.7193L94.699 32.7468L120.764 47.8436Z",
    fill: "#18113C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M179.875 54.5316L153.816 69.5522V99.6764L179.875 84.6488V54.5316Z",
    fill: "#18113C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M151.485 65.5697L177.551 50.4662L151.485 35.4525L125.42 50.4662L151.485 65.5697Z",
    fill: "#18113C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M153.816 135.122L179.875 120.102V89.9774L153.816 105.005V135.122Z",
    fill: "#18113C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M116.109 15.0204L90.0439 0L63.9783 15.0204L90.0439 30.0408L116.109 15.0204Z",
    fill: "#18113C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.212341 155.547L26.2708 170.574V140.526L0.212341 125.43V155.547Z",
    fill: "#18113C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3227 47.8436L85.3881 32.7468L59.3227 17.7193L33.2641 32.7468L59.3227 47.8436Z",
    fill: "#18113C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M179.875 125.43L153.816 140.526V170.574L179.875 155.547V125.43Z",
    fill: "#18113C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M149.154 143.163L123.096 158.253V188.301L149.154 173.28V143.163Z",
    fill: "#18113C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M118.434 89.9774L92.368 105.005V135.122L118.434 120.102V89.9774Z",
    fill: "#18113C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M118.434 125.43L92.368 140.526V170.574L118.434 155.547V125.43Z",
    fill: "#18113C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M146.823 68.1994L120.764 53.179L94.699 68.1994L120.764 83.2962L146.823 68.1994Z",
    fill: "#18113C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M116.109 50.4662L90.0439 35.4525L63.9783 50.4662L90.0439 65.5697L116.109 50.4662Z",
    fill: "#18113C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M149.154 72.2581L123.096 87.2785V117.396L149.154 102.375V72.2581Z",
    fill: "#18113C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M123.096 152.848L149.154 137.828V107.704L123.096 122.8V152.848Z",
    fill: "#18113C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2708 105.005L0.212341 89.9774V120.102L26.2708 135.122V105.005Z",
    fill: "#18113C"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0585 175.322L62 160.294V190.418L88.0585 205.439V175.322Z",
    fill: "#18113C"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M116.109 86.0019L90.0439 70.9051L63.9783 86.0019L90.0439 101.022L116.109 86.0019Z",
    fill: "#18113C"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7193 105.005L61.6537 89.9774V120.102L87.7193 135.122V105.005Z",
    fill: "#18113C"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7193 140.526L61.6537 125.43V155.547L87.7193 170.574V140.526Z",
    fill: "#18113C"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3881 68.1994L59.3227 53.179L33.2641 68.1994L59.3227 83.2962L85.3881 68.1994Z",
    fill: "#18113C"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6676 50.4662L28.602 35.4525L2.54337 50.4662L28.602 65.5697L54.6676 50.4662Z",
    fill: "#18113C"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M30.933 173.28L56.9986 188.301V158.253L30.933 143.163V173.28Z",
    fill: "#18113C"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9986 87.2785L30.933 72.2581V102.375L56.9986 117.396V87.2785Z",
    fill: "#18113C"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9986 122.8L30.933 107.704V137.828L56.9986 152.848V122.8Z",
    fill: "#18113C"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2708 69.5522L0.212341 54.5316V84.6488L26.2708 99.6764V69.5522Z",
    fill: "#18113C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsTrans);
export default __webpack_public_path__ + "static/media/icons-trans.cfba1dfcdff12e9b51ca2e099df39e0a.svg";
export { ForwardRef as ReactComponent };